export default {
    computed: {
        order1() {
            if (process.client) {
                const bp = this.$vuetify.breakpoint
                if (bp.smAndDown) {
                    return 'order:1'
                } else {
                    return ''
                }
            } else {
                return {}
            }
        },
        order2() {
            if (process.client) {
                const bp = this.$vuetify.breakpoint
                if (bp.smAndDown) {
                    return 'order:2'
                } else {
                    return ''
                }
            } else {
                return {}
            }
        },
        order3() {
            if (process.client) {
                const bp = this.$vuetify.breakpoint
                if (bp.smAndDown) {
                    return 'order:3'
                } else {
                    return ''
                }
            } else {
                return {}
            }
        }
    }
}
